const Setup = {
  PSEUDO: false,
  RESERVE: false,
  MEETING: false,
  SUCCESS: true,
};

export default Setup;
